import { render, staticRenderFns } from "./ProductPriceSection.vue?vue&type=template&id=543427e5&scoped=true&"
import script from "./ProductPriceSection.vue?vue&type=script&lang=js&"
export * from "./ProductPriceSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceSection.vue?vue&type=style&index=0&id=543427e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543427e5",
  null
  
)

export default component.exports